module.exports = __webpack_public_path__ + "img/photo1.c661dcf5.jpg";